export default {
  superDesktop: 'Bericht',
  appNotifications: 'App-Benachrichtigungen',
  home: 'Startseite',
  peopleDirectory: 'Menschen',
  peopleList: 'Listen',
  listDetails: 'Listendetails',
  roles: 'Rollen',
  conversations: 'Gespräche',
  conversationMetrics: 'Konversationsmetriken',
  conversationSettings: 'Unterhaltungseinstellungen',
  businesses: 'Unternehmen',
  businessDetails: 'Geschäftsdetails',
  campaigns: 'Kampagnen',
  newSms: 'Neue SMS',
  newCampaign: 'Neue Kampagne',
  campaignDetails: 'Kampagnendetails',
  triggers: 'Trigger',
  notifications: 'Benachrichtigungen',
  speechToText: 'Rede zu Textprojekten',
  authenticator: 'Authentifikator',
  forms: 'Formen',
  events: 'Ereignisse',
  eventDetail: 'Ereignisdetails',
  assistants: 'Assistenten',
  promotors: 'Promotoren',
  productsCategories: 'Product categorieën',
  products: 'Produkte',
  productsSales: 'Produktkäufe',
  companyNotFound: 'Es wurden keine Unternehmen gefunden',
  upToDateNotifications: 'Sie sind mit Ihren Benachrichtigungen auf dem neuesten Stand',
  /* ORDERS */
  clients: 'Kunden',
  colors: 'Farben',
  containerTypes: 'Containertypen',
  purchases: 'Einkäufe',
  purchaseDetail: 'Einkaufsdetails',
  sellers: 'Verkäufer',
  suppliers: 'Lieferanten',
  /* END ORDERS */
  settings: 'Einstellungen',
  details: 'Details',
  administrators: 'Administratoren',
  billing: 'Abrechnung',
  payments: 'Zahlungen',
  creditCards: 'Kreditkarten',
  newApp: 'Neue Anwendung',
  newCompany: 'Neues Unternehmen',
  newPage: 'Neue Seite',
  servicesPerPage: 'Dienstleistungen pro Seite',
  balance: 'Gleichgewicht',
  loadingTariffs: 'Ladetarife',
  noTariffsOnTheListYet: 'Noch keine Tarife auf der Liste',
  shortenLink: 'Verkürzung der Verbindung',
  addCreditCart: 'Hinzufügen von Kreditkarte',
  addCard: 'Karte hinzufügen',
  load: 'Laden',
  changePassword: 'Kennwort ändern',
  exit: 'Ausfahrt',
  support: 'Unterstützung',
  /* TOOLBAR CARD */
  services: 'Dienstleistungen',
  value: 'Wert',
  addCreditCard: 'Hinzufügen von Kreditkarte',
  createAplication: 'App erstellen'
}
